<div class="SLV2-test-instruction-popup">

    <ng-container *ngIf="false">
        <h3 class="SLV2-popup-hdng">Chapter name</h3>
        <div class="SLV2-popup-content-area">
            <div class="SLV2-pop-datainfo">
                <label>Test Instructions :</label>
                <ul class="SLV2-pop-datainfo-list">
                    <li>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</li>
                    <li>Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</li>
                    <li>When an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic. five centuries, but also the leap into electronic</li>
                </ul>
            </div>
        </div>
        <div class="SLV2-popup-actn-area">
            <div class="SLV2-popup-numbr-count" *ngIf="counterAnimation">
                <img src="selflearnv2-ui/assets/img/self-learn-v2/counter-animation.gif" />
            </div>
            
            <ng-container *ngIf="!counterAnimation">
                <button class="SLV2-popup-solid-btn" (click)="startTest()">Start Test</button>
            </ng-container>
            
            
        </div>
    </ng-container>




    <ng-container *ngIf="true">
        <h3 class="SLV2-popup-hdng">{{data.topicName}}</h3>
        <div class="SLV2-popup-content-area secondScreen">
            <img src="selflearnv2-ui/assets/img/self-learn-v2/puzzel-animated.gif" class="puzzel" />
            <h5 class="sndscreen-hdng">Mark <b>{{data.correctAnswers}} correct</b> answers<br> to clear this level!</h5>
        </div>
    </ng-container>



</div>
